<template>
    <div class="invitations-admin-view">
        <AdminTable class="ma-4"
                    :items="items"
                    :get-headers="getHeaders" />
    </div>
</template>

<script>
    import { DateTime } from "luxon";

    import AdminTable from "@/components/admin/AdminTable.vue";

    export default {
        components: {
            AdminTable
        },

        data() {
            return {
            };
        },

        created() {
            this.$store.dispatch("admin/loadInvitations");
        },

        computed: {
            currentLocale() {
                return this.$store.state.currentLocale;
            },

            items() {
                return this.$store.state.admin.invitations
                    .map(e => ({
                        id: e.id,
                        isActive: this.getBoolString(e.isActive),
                        isAccepted: this.getBoolString(e.isAccepted),
                        isDeclined: this.getBoolString(e.isDeclined),
                        dateTime: this.getDateTime(e.dateTime),
                        title: e.title,
                        message: e.message,
                        senderId: e.sender.id,
                        senderName: e.sender.userName,
                        recipientId: e.recipient.id,
                        recipientName: e.recipient.userName,
                        recipientEmail: e.recipientEmail,
                        groupId: e.group.id,
                        groupGuid: e.group.guid,
                        groupName: e.group.name,
                        rawItem: e
                    }));
            }
        },

        watch: {

        },

        methods: {
            getBoolString(bool) {
                return bool === true
                    ? "Да"
                    : "Нет";
            },

            getDateTime(isoDateTime) {
                return DateTime.fromISO(isoDateTime).setLocale(this.currentLocale).toFormat("yyyy.MM.dd HH:mm");
            },

            getHeaders() {
                return [
                    {
                        title: "Id",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "id"
                    },
                    {
                        title: "Заголовок",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "title"
                    },
                    {
                        title: "Сообщение",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "message"
                    },
                    {
                        title: "Id отправителя",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "senderId"
                    },
                    {
                        title: "Отправитель",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "senderName"
                    },
                    {
                        title: "Id получателя",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "recipientId"
                    },
                    {
                        title: "Получатель",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "recipientName"
                    },
                    {
                        title: "Указанный email",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "recipientEmail"
                    },
                    {
                        title: "Id группы",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "groupId"
                    },
                    {
                        title: "Guid группы",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "groupGuid"
                    },
                    {
                        title: "Название группы",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "groupName"
                    },
                    {
                        title: "Активно",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "isActive"
                    },
                    {
                        title: "Принято",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "isAccepted"
                    },
                    {
                        title: "Отклонено",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "isDeclined"
                    }
                ];
            }
        }
    };
</script>

<style lang="scss">
    .invitations-admin-view {
    }
</style>